/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EdrApiKeyEntry } from './edrApiKeyEntry';


/**
 * EDR organization details with associated API keys.
 */
export interface EdrOrgWithApiKeysEdrOrg { 
    /**
     * The organization ID for the EDR service.
     */
    org_id: string;
    /**
     * The numeric Carbon Black organization identifier (CBC org_id). Populated only for Carbon Black on-premises orgs; null for CrowdStrike.
     */
    cb_org_id?: number;
    /**
     * The region/POP ID for the EDR cloud instance.
     */
    region: string;
    /**
     * The API endpoint URL for the EDR service.
     */
    endpoint: string;
    /**
     * List of API keys associated with this EDR organization.
     */
    api_keys: Array<EdrApiKeyEntry>;
}

